import { Injectable } from "@angular/core";
import { AppConfigService } from "./app-config.service";
import amplitude from "amplitude-js";

@Injectable()
export class AmplitudeService 
{
    constructor() { }

    init(amplitude_key: string) {
        amplitude.getInstance().init(amplitude_key);
    }

    initUser(userName:string)
    {
        amplitude.getInstance().setUserId(userName);
    }

    logUrlEvent(url:string)
    {
        amplitude.getInstance().logEvent('routerEvent', {url:url} );
    }
    
    logClickEvent(event: MouseEvent): any {
        try {
            let target = event.target as any;
            do {
                if ((target.id && this.targetIds.includes(target.id))) {
                    this.logAmplitudeEvent(target.id);
                    break;
                }
                else if (target.classList) {
                    let classLogged = false;
                    for (let i = 0; i < target.classList.length; i++) {
                        const c = target.classList[i];
                        if (this.targetClasses.some(tg => tg == c)) {
                            this.logAmplitudeEvent(c);
                            classLogged = true;
                            break;
                        }
                    }
                    if (classLogged) break;
                }
                target = target.parentElement;
            } while (target);
        }
        catch (err) {
            console.error(`Amplitude provider error.`, err);

        }
    }

    logEvent(eventName:string): any {
        this.logAmplitudeEvent(eventName);
    }

    logSuggestedReplyClick(replyId: string): any {
       this.logAmplitudeEvent(`fac-suggested-reply-id-${replyId}`);
      }

    private logAmplitudeEvent(targetEventName: any) {
        amplitude.getInstance().logEvent(targetEventName);        
    }

    private targetIds = [
      "fac-cases-alert-type-dropdown",
      "fac-cases-practitioners-dropdown",
      "fac-cases-patient-profile-button",
      "fac-cases-close-note-button",
      "fac-cases-close-confirm-chat-button",
      "fac-cases-post-note-button",
      "fac-cases-send-message-modal-button",
      "fac-cases-send-message-button",
      "fac-patients-center-dropdown",
      "fac-patients-new-patient-button",
      "fac-patients-new-patient-option",
      "fac-patients-import-patients-option",     
      "fac-patients-add-visit-close-modal-button",  
      "fac-patients-add-visit-modal-button",  
      "fac-patients-confirm-visit-close-modal-button",  
      "fac-patients-confirm-visit-modal-button",  
      "fac-patients-send-now-checkbox",  
      "fac-visits-from-dropdown",
      "fac-visits-to-dropdown",
      "fac-visits-centers-dropdown",
      "fac-visits-practitioners-dropdown",
      "fac-visits-hide-cancelled-checkbox",
      "fac-visits-edit-appointment-close-button",
      "fac-visits-date-toggle-modal-button",
      "fac-visits-practitioner-modal-dropdown",
      "fac-visits-treatment-modal-dropdown",
      "fac-visits-cancel-modal-button",
      "fac-visits-save-modal-button",
      "fac-profile-edit-profile-button",
      "fac-profile-send-button",
      "fac-profile-force-send-modal-button",
      "fac-profile-stop-messages-modal-button",
      "fac-analytics-centers-dropdown",
      "fac-analytics-practitioner-dropdown",
      "fac-analytics-year-dropdown",
      "fac-analytics-month-dropdown",
      "fac-analytics-apply-filter-button",
      "fac-analytics-cc-ignore-date-checkbox",
      "fac-analytics-pf-sort-by-dropdown",
      "fac-analytics-pf-filter-by-dropdown",
      "fac-analytics-pf-view-dropdown",
      "fac-analytics-pf-ignore-date-checkbox",
      "fac-analytics-pf-export-button",    
      "fac-analytics-export-parameters-dropdown",
      "fac-analytics-export-patient_response-option",
      "fac-analytics-export-alerts-option",
      "fac-analytics-export-notes_report-option",
      "fac-analytics-export-delivery_sms-option",
      "fac-analytics-export-delivery_email-option",
      "fac-analytics-export-patient_feedback-option",
      "fac-analytics-export-create-report-button",
      "fac-settings-add-member-button",
      "fac-settings-edit-member-button",
      "fac-settings-deactivate-member-button",
      "fac-settings-resend-email-button",
      "fac-settings-add-center-button",
      "fac-settings-edit1-center-button",
      "fac-settings-edit2-center-button",
      "fac-settings-deactivate-center-button",
    ];
    
    private targetClasses = [       
      "fac-cases-resolve-dropdown",
      "fac-cases-add-note-button",
      "fac-cases-see-more-button",
      "fac-cases-acknowledged-option",
      "fac-cases-contacted-option",
      "fac-patients-new-appointment-button",
      "fac-patients-edit-patient-button",
      "fac-visits-edit-appointment-button",
      "fac-profile-appointment-settings-button",
      "fac-profile-add-note-button",
      "fac-profile-resolve-dropdown",
      "fac-profile-acknowledged-option",
      "fac-profile-contacted-option",
      "fac-profile-see-more-button",
      "fac-profile-force-send-button",
      "fac-profile-stop-messages-button",
      "fac-profile-edit-visit-button",
    ];

    public static matTabLabels = {
        facAnalyticsAnalyticsLabel : "fac-analytics-analytics-label",
        facAnalyticsCommunicationsLabel : "fac-analytics-communications-label",
        facAnalyticsReportsLabel:"fac-analytics-reports-label",
        facAnalyticsPerformanceReportLabel:"fac-analytics-performance-report-label",
        facAnalyticsDataExportLabel:"fac-analytics-data-export-label",
        facSettingsManageMembersLabel:"fac-settings-manage-members-label",
        facSettingsManageCentersLabel:"fac-settings-manage-centers-label",
    };
}